import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { AgremoCreditType } from './agremo-credit-type.model';

/**
 * An Agremo credit block from `/admin/agremo/credits` (hub `admin-agremo-credits-controller.ts`).
 * Writable fields the hub didn't send stay `undefined`; an explicit `null` stays `null`.
 */
export class AgremoCreditBlock extends Base {
  // Writable via PUT /admin/agremo/credits/:id
  totalCredits?: number | null;
  /** ISO timestamp as sent by the hub. */
  expiresAt?: string | null;

  // Set on create only
  organizationId?: string | null;
  /**
   * Native unit of the block. Pre-2026-05-20 hub builds omit it; those rows are all legacy
   * "1 credit = 1 analysis" blocks, so a missing value reads as `'analysis'`.
   */
  creditType: AgremoCreditType;

  // Read-only, set by the hub
  /** Server-computed remaining balance in the block's native unit. */
  remainingCredits: number;
  /** ISO timestamp as sent by the hub. */
  archivedAt?: string | null;
  archivedBy?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.totalCredits = nullableNumber(source['totalCredits']);
    this.expiresAt = nullableString(source['expiresAt']);
    this.organizationId = nullableString(source['organizationId']);
    this.creditType = (nullableString(source['creditType']) ?? 'analysis') as AgremoCreditType;
    this.remainingCredits = countOrZero(source['remainingCredits']);
    this.archivedAt = nullableString(source['archivedAt']);
    this.archivedBy = nullableString(source['archivedBy']);
  }
}
